module.exports = {"headerColumns":{"engravedId":"OV-chipkaartnummer","ascription":"Tenaamstelling (1)","ascription1":"Tenaamstelling (2)","ascription2":"Tenaamstelling (3)"},"replacementStatusOnlyActive":"Toon alleen actieve passen","replacementStatusOnlyReplaced":"Toon alleen inactieve passen","replacementStatusAll":"Toon alle passen","detailsNotFound":"De details van deze pas konden niet worden geladen","activeCommercialStatus":{"active":"actief","inactive":"niet actief"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/card.json
// module id = Zkql
// module chunks = 1